<template>
  <div id="app">
    <component :is="layout">
      <router-view />
    </component>
  </div>
</template>

<script>
import DefaultLayout from './layouts/Default.vue'
import Meta from '@/helpers/meta'

export default {
  metaInfo: Meta,
  components: {
    DefaultLayout,
  },
  computed: {
    layout() {
      return 'default-layout'
    },
  },
}
</script>

<style>
body {
  margin: 0;
  font-family: 游ゴシック, YuGothic, ヒラギノ角ゴ ProN W3, Hiragino Kaku Gothic ProN, メイリオ, Meiryo, sans-serif;
}
</style>
